import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import VisitorHeader from "../../../common_components/visitor_module_header";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action'
import { attendeeTypeActionId, cityActionId, countryActionId, countryIWithCodeActionId, exhibitorBadgeDaysActionId, pincodeActionId, visitorTypeListActionId, stateActionId, toastError, GSTvalidationActionId, visitPurposeActionId, companyTurnOverActionId, exhibitionStatusActionId, toastSuccess, industryChaptersActionId, genderActionId, primaryChapterListActionId, seminarInterestActionId, AccountTypeActionId, B2BTimeslotActionID } from "../../../utils/constants";
import { data } from "jquery";
import { getVistiorRegistarionDetails_action, visitorRegistrationNext_action, verifyVisitorEmail_action, visitorRegistrationGroupNext_action, delVisaDoc_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import Resizer from "react-image-file-resizer";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo"
import Modal from 'react-bootstrap/Modal';
import { emailValidator } from "../../../utils/Validator";
import DatePicker from "react-datepicker";
import { delegateRegistrationGroupSubmit_action, getDelegateDetailsStep1_action, getDelegateFirldList_action, deleteVisaDoc_action, delegateRegistrationSubmit_action } from "../../../actions/delegate_module_action/delegate_registration_action/delegate_registration_action"
import { getExhNoteDetails_action } from "../../../actions/admin_module_action/master_action/exhibition_master_action/exh_note_action"
import { Tab, Nav, ToggleButton, ButtonGroup, Container, Row, Stack } from "react-bootstrap";
import moment from "moment";

class DelegateAdditionalDetails extends Component {

    // Initialized Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            isOpen3: false,
            agreeTerms: false,
            showFieldList: [],
            note: [],
            DelegateRegistrationID: '',
            AccountTypeID: '',
            AccountID: '',
            DelegateRegistrationNo: '',
            countryList: [],
            chapterList: [],
            visitPurposeList: [],
            daysList: [],
            primaryChapterListData: [],
            level0: [],
            level2: [],
            level3: [],
            level4: [],
            primaryChapterListLevel3: [],
            primaryChapterListLevel4: [],
            B2bMeetingList: [],
            seminarInterestList: [],
            isOtherOpen: false,
            chapterErr: '',
            other: '',
            visitPurposeErr: '',
            isInterestTwo: false,
            isInterestOne: false,
            b2bErr: '',
            ChapterHallErr: '',
            needVisaAssistance: false,
            passName: '',
            passNameErr: '',
            applicantMobNo: '',
            applicantMobNoErr: '',
            preApplicantMobNo: '',
            applicantEmail: '',
            applicantEmailErr: '',
            IsIntrestedForB2B: false,
            passNo: '',
            passNoErr: '',
            passDateErr: '',
            passDate: '',
            passExipryDate: '',
            passExipryDateErr: '',
            passCountry: '',
            passCountryErr: '',
            isPassportFilePresent: false,
            isVisaApplied: false,
            passportFileErr: '',
            passportFile: '',
            passPortFileName: '',
            passportFileType: '',
            passportFilePath: '',
            SeminarErr: '',
            daysErr: '',
            countryId: '',
            email: '',
            mobNo: '',
            preMobNo: '',
            visaErr: '',
            HTMLEDITOR: false,
            HtmlContent: '',
            accountTypeList: []
        }
        this.getFillList = this.getFillList.bind(this)
        this.getDetails = this.getDetails.bind(this)
        this.onPrevClick = this.onPrevClick.bind(this)
        this.getNotes = this.getNotes.bind(this)
        this.handleGroupFinalSubmit = this.handleGroupFinalSubmit.bind(this)
        this.onSelectPrimaryChapter = this.onSelectPrimaryChapter.bind(this)
        this.onSelectPurpose = this.onSelectPurpose.bind(this)
        this.handleFinalSubmit = this.handleFinalSubmit.bind(this)
        this.otherDetailsChange = this.otherDetailsChange.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.recordTwo = this.recordTwo.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.recordThree = this.recordThree.bind(this)
        this.onSelectInterest = this.onSelectInterest.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        this.onSelect = this.onSelect.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.onCheckedSeminar = this.onCheckedSeminar.bind(this)
        this.onSelectDates = this.onSelectDates.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.verifyEmail = this.verifyEmail.bind(this)
        this.onCountrySelect = this.onCountrySelect.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.showMandatoryFields = this.showMandatoryFields.bind(this)
        this.getFieldList = this.getFieldList.bind(this)


    }

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    componentDidMount() {
        // getting Exhibition Code from Url
        // sessionStorage.setItem("sessionExhibitionID", exhCode)
        // console.log("h7hyhyhh", this.props.location.state, 'this.props.location.state', exhCode)
        // if (this.props.location != null && this.props.location.state == null) {
        //     this.getFillList(seminarInterestActionId, '', '', 3, '', '').then(res => {
        //         //exhibition status..................
        //     })
        // } else if (this.props.location.state != null && this.props.location.state.is_previous) {
        window.scrollTo(0, 0);
        this.getFillList(seminarInterestActionId, '', '', 3, '', '').then(res => {
            this.getFillList(exhibitorBadgeDaysActionId, '', '', '', '', '').then(res => {
                this.getFillList(primaryChapterListActionId, '', '', '', '', '').then(res => {
                    this.getFillList(countryActionId, '', '', '', '', '').then(res => {
                        this.getFillList(industryChaptersActionId, '', '', '', '', '').then(res => {
                            this.getFillList(visitPurposeActionId, '', '', '', '', '').then(res => {
                                this.getFillList(AccountTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                    this.getFillList(B2BTimeslotActionID, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(res => {
                                        //exhibition status..................
                                        setTimeout(() => {
                                            // console.log(sessionStorage.getItem('showFieldList').split(',').map(Number))
                                            console.log(sessionStorage.getItem('showFieldList'))
                                            // const arr = str.split(',').map(Number);
                                            // var Arr = sessionStorage.getItem('showFieldList').split(',').map(Number)
                                            this.getFieldList(sessionStorage.getItem('DelegateTypeID'))
                                            this.getDetails()
                                            this.getNotes()
                                        }, 200);
                                    })
                                })
                            })
                        })
                    })
                })
            })
        }).catch((e) => {
            window.location.reload()
            console.log(e);
        });
        // }
    }

    getFieldList(typeId) {
        const { attendeeList, industryChapterList, GroupDetailsList, primaryChapterListData, primaryChapterListDataModal, level0Modal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal, countryList,
            stateList, turnOverList,
            cityList,
            pincodeList,
            genderList,
            gstValidtionList,
            chapterList, chapterListModal,
            visitorTypeList,
            visitPurposeList, visitPurposeListModal,
            interestList,
            daysList, daysListModal, B2bMeetingListmodal,
            B2bMeetingList } = this.state
        // this.setState({ isLoading: true })
        this.props.getDelegateFirldList_action(typeId)
            .then((data) => {
                if (data.error != 1) {
                    var showFieldListArr = []
                    if (data.data[1] != null) {
                        if (data.data[1].length > 0) {
                            for (var i = 0; i < data.data[1].length; i++) {
                                var obj = {
                                    'id': data.data[1][i].FieldID, 'mandatory': data.data[1][i].IsMandatory, 'name': data.data[1][i].FieldName
                                }
                                showFieldListArr.push(obj)
                            }
                        }
                    }
                    console.log('data.data', showFieldListArr)
                    sessionStorage.setItem('showFieldList', JSON.stringify(showFieldListArr))
                    this.setState({
                        showFieldList: showFieldListArr
                    })
                }
            })
    }

    onPrevClick(e) {
        e.preventDefault()
        const { accountId, visitorId } = this.state
        { console.log('.............', JSON.parse(sessionStorage.getItem('isLinkOpen'))) }
        if (JSON.parse(sessionStorage.getItem('isLinkOpen'))) {
            this.props.navigate(`/delegateRegistration/${sessionStorage.getItem("sessionExhibitionID")}`, { state: { is_previous: true } })
        } else {
            this.props.navigate(`/delegateRegistration`, { state: { is_previous: true } })
        }
    }


    calculateRowspan(data) {
        // Create a map to count children for each parent seminar
        const parentChildMap = {};

        // Initialize Rowspan for each item and count the children
        data.forEach(item => {
            item.Rowspan = 0; // Default Rowspan for all items

            if (item.ParentSeminarID !== null) {
                // Increment child count for the parent
                parentChildMap[item.ParentSeminarID] = (parentChildMap[item.ParentSeminarID] || 0) + 1;
            }
        });

        // Assign Rowspan to parent seminars
        data.forEach(item => {
            if (item.ParentSeminarID === null) {
                // If it's a parent, Rowspan is itself plus its children
                item.Rowspan = (parentChildMap[item.SeminarID] || 0) + 1;
            }
        });

        return data;
    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === seminarInterestActionId) {
                            data.data.sort((a, b) => a.SeqNo - b.SeqNo);
                            data.data.length > 0 && data.data.map((item) => {
                                item.isSelect = false
                            })
                            console.log("Visitor Interest List 121212", data.data)
                            const result = this.calculateRowspan(data.data);
                            this.setState({
                                seminarInterestList: result,
                                // isLoading: false
                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === primaryChapterListActionId) {
                            console.log("primaryChapterListActionId 121212", data.data)
                            async function seqnoFormat(arr) {
                                for (var i = 0; i < arr.length; i++) {
                                    if (arr[i].seqno != '' && arr[i].seqno != null) {
                                        arr[i].ChapterName.trim()
                                        // console.log(arr[i].ChapterName)
                                        if (/^\d$/.test(arr[i].ChapterName[0])) {
                                            for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                                if (arr[i].ChapterName[j] == ' ') {
                                                    var str = arr[i].ChapterName.slice(j)
                                                    var finalName = arr[i].seqno + str
                                                    arr[i].ChapterName = finalName
                                                    // console.log("primaryChapterListActionId 121212", i, finalName)
                                                    break
                                                }
                                            }
                                        } else {
                                            var str = arr[i].ChapterName
                                            var finalName = arr[i].seqno + ' ' + str
                                            arr[i].ChapterName = finalName
                                        }
                                    }
                                }
                                return
                            }

                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                if (data.data['primaryChapter'][i].ChapterID == 2046) {
                                    data.data['primaryChapter'][i].ChapterName = 'TECHNICAL TEXTILE PRODUCTS & HOME TEXTILE PRODUCT'
                                }
                                if (data.data['primaryChapter'][i].ChapterID == 2033) {
                                    data.data['primaryChapter'].splice(i, 1)
                                }
                                console.log(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                for (var j = 0; j < data.data['level2'].length - 1 - i; j++) {
                                    var seq1 = data.data['level2'][j].seqno
                                    var seq2 = data.data['level2'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level2'][j]
                                        data.data['level2'][j] = data.data['level2'][j + 1]
                                        data.data['level2'][j + 1] = temp;
                                    }
                                }
                                data.data['level2'][i].primaryChapterId = data.data['level2'][i].ParentChapterID
                                seqnoFormat(data.data['level2'])
                            }
                            console.log(data.data['primaryChapter'])
                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                for (var j = 0; j < data.data['primaryChapter'].length - 1 - i; j++) {
                                    var seq1 = data.data['primaryChapter'][j].seqno
                                    var seq2 = data.data['primaryChapter'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['primaryChapter'][j]
                                        data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                        data.data['primaryChapter'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                    console.log(data.data['primaryChapter'][i].seqno, i)
                                }
                                // seqnoFormat(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level3'].length; i++) {
                                for (var j = 0; j < data.data['level3'].length - 1 - i; j++) {

                                    var seq1 = data.data['level3'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level3'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')

                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level3'][j]
                                        data.data['level3'][j] = data.data['level3'][j + 1]
                                        data.data['level3'][j + 1] = temp;
                                    }
                                }
                                for (var j = 0; j < data.data['level2'].length; j++) {
                                    if (data.data['level2'][j].ChapterID == data.data['level3'][i].ParentChapterID) {
                                        data.data['level3'][i].primaryChapterId = data.data['level2'][j].ParentChapterID
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level3'])
                            }
                            for (var i = 0; i < data.data['level4'].length; i++) {
                                for (var j = 0; j < data.data['level4'].length - 1 - i; j++) {
                                    var seq1 = data.data['level4'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level4'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level4'][j]
                                        data.data['level4'][j] = data.data['level4'][j + 1]
                                        data.data['level4'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                for (var j = 0; j < data.data['level3'].length; j++) {
                                    if (data.data['level3'][j].ChapterID == data.data['level4'][i].ParentChapterID) {
                                        for (var k = 0; k < data.data['level2'].length; k++) {
                                            if (data.data['level2'][k].ChapterID == data.data['level3'][j].ParentChapterID) {
                                                data.data['level4'][i].primaryChapterId = data.data['level2'][k].ParentChapterID
                                                break
                                            }
                                        }
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level4'])
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                data.data['level2'][i].isHighlight = false;
                            }
                            const level0list = data.data['level0'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const primaryChapterListDatalist = data.data['primaryChapter'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level2list = data.data['level2'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level3list = data.data['level3'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level4list = data.data['level4'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'] ? data.data['primaryChapter'] : [],
                                level0: data.data['level0'] ? data.data['level0'] : [],
                                level2: data.data['level2'] ? data.data['level2'] : [],
                                level3: data.data['level3'] ? data.data['level3'] : [],
                                level4: data.data['level4'] ? data.data['level4'] : [],
                                // primaryChapterListDataModal: primaryChapterListDatalist ? primaryChapterListDatalist : [],
                                // level0Modal: level0list ? level0list : [],
                                // level2Modal: level2list ? level2list : [],
                                // level3Modal: level3list ? level3list : [],
                                // level4Modal: level4list ? level4list : [],

                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                countryList: data != null ? data.data : [],
                                // personalCountryList: data.data,
                                // tempPersonalCountryList: data.data,
                                // delgationCountryList: data.data,
                                // tempDelegationCountryList: data.data,
                                // passCountryList: data.data,
                                // tempPassCountryList: data.data,
                                // isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === industryChaptersActionId) {
                            console.log("industryChaptersActionId 121212", data.data)
                            // var list = []
                            // var listModal = []
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                OtherNames: '',
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                OtherNames: '',
                            }));
                            this.setState({
                                chapterList: list,
                                // chapterListModal: listModal,

                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === visitPurposeActionId) {
                            console.log(" Visit Purpose List data", data.data)
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                otherDetail: ""
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                otherDetail: ""
                            }));
                            this.setState({
                                visitPurposeList: list,
                                // visitPurposeListModal: listModal,
                            })
                            // if (!isPrevious) {
                            //     this.setState({ isLoading: false, })
                            // }
                            resolve(true)
                        }
                        if (actionID === B2BTimeslotActionID) {
                            // console.log(" Visit Purpose List data", data.data)
                            var B2bDates = []
                            var tempData = data.data.map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            tempData.sort((a, b) => {
                                const dateA = new Date(a.B2BDate);
                                const dateB = new Date(b.B2BDate);

                                // First compare by B2BDate
                                if (dateA < dateB) return -1;
                                if (dateA > dateB) return 1;

                                // If B2BDate is the same, compare by B2BStartTime
                                if (a.B2BStartTime < b.B2BStartTime) return -1;
                                if (a.B2BStartTime > b.B2BStartTime) return 1;

                                return 0;
                            });
                            const uniqueDAta = tempData.filter((value, index, self) => {
                                // Create a unique identifier using both name and no
                                const identifier = `${value.B2BDate}-${value.B2BLocation}`;

                                // Check if this combination has appeared before
                                return index === self.findIndex((t) => `${t.B2BDate}-${t.B2BLocation}` === identifier);
                            });

                            const keysToKeep = ['B2BDate', 'B2BLocation'];

                            // Remove keys from each object
                            const modifiedArray = uniqueDAta.map(obj => {
                                // Create a new object that only includes the keys you want to keep
                                return Object.keys(obj).reduce((newObj, key) => {
                                    if (keysToKeep.includes(key)) {
                                        newObj[key] = obj[key];
                                    }
                                    return newObj;
                                }, {});
                            });

                            modifiedArray.length > 0 && modifiedArray.map((item) => {
                                var obj = {}
                                obj.date = item
                                // objModal.date = item
                                obj.timeSlotList = []
                                data.data.length > 0 && data.data.map((item2) => {
                                    if (item.B2BDate == item2.B2BDate && item.B2BLocation == item2.B2BLocation) {
                                        var timeobj = {}
                                        timeobj.timeslot = `${item2.B2BStartTime} To ${item2.B2BEndTime}`
                                        timeobj.IsBooked = item2.IsBooked
                                        timeobj.isSelect = false
                                        timeobj.B2BTimeSlotID = item2.B2BTimeSlotID
                                        obj.timeSlotList.push(timeobj)
                                        // objModal = { ...obj }
                                    }
                                })

                                // finalDateList.push(obj)
                                item.timeSlotList = obj.timeSlotList
                                // item.rowSpan = obj.timeSlotList.length
                                // finalDateListModal.push(objModal)
                            })

                            data.data.length > 0 && data.data.map((item) => {
                                if (!B2bDates.includes(item.B2BDate)) {
                                    B2bDates.push(item.B2BDate)
                                }
                            })
                            B2bDates.map(item => {
                                var dateCount = 0
                                modifiedArray.map(obj => {
                                    if (item == obj.B2BDate) {
                                        dateCount++
                                        obj.rowSpan = 0
                                    }
                                })
                                for (var i = 0; i < modifiedArray.length; i++) {
                                    if (item == modifiedArray[i].B2BDate) {
                                        modifiedArray[i].rowSpan = dateCount
                                        break
                                    }
                                }
                            })

                            // const finalDateListModal = finalDateList.map(item => ({
                            //     ...item // Create a new object for the modal list
                            // }));
                            // data.data.length > 0 && data.data.map((item) => {
                            //     item.isSelect = false
                            //     item.otherDetail = ""
                            // })
                            // console.log(finalDateListModal, 'finalDateList', modifiedArray)
                            this.setState({
                                B2bMeetingList: modifiedArray,
                                // B2bMeetingListmodal: finalDateListModal,
                            })
                            // // if (!isPrevious) {
                            // //     this.setState({ isLoading: false, })
                            // // }
                            resolve(true)
                        }
                        if (actionID === AccountTypeActionId) {
                            this.setState({
                                accountTypeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === exhibitorBadgeDaysActionId) {
                            console.log("exhibitor data", data.data)
                            var DateList = []
                            // var DateListModal = []
                            // data.data.map(item => {
                            //     DateList.push(item)
                            // })
                            // data.data.map(item => {
                            //     DateListModal.push(item)
                            // })
                            data.data.map((item) => {
                                // item.isSelect = false
                                // item.isReadOnly = false
                                // item.Code = item.VisitDate
                                var mapData = {
                                    "Code": item['VisitDate'],
                                    "VisitDate": item['VisitDate'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                    'PriceINR': item['PriceINR'],
                                    'PriceUSD': item['PriceUSD'],
                                    'PromoCode': null,
                                    'PromoCodeDiscount': null
                                }
                                DateList.push(mapData)
                                // DateListModal.push(mapData)
                            })
                            const DateListModal = DateList.map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            console.log('DateListxxxxxxxxxxxxx', DateList)
                            this.setState({
                                daysList: DateList,
                                // daysListModal: DateListModal,
                                // isLoading: false,
                                isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            resolve(true)
                        }
                    } else {
                        // .catch((e) => {
                        window.location.reload()
                        console.log(data.error);
                        // });
                    }
                }).catch((e) => {
                    window.location.reload()
                    console.log(e);
                });
        })
    }

    handleGroupFinalSubmit() {
        const { isLoading, arrivalDate, showFieldList, arrivalDateErr, agreeTerms, departureDate, departureDateErr } = this.state
        var Err = true
        if (!agreeTerms && this.showMandatoryFields(29, 2)) {
            Err = false
        }
        if (Err) {
            this.setState({ isLoading: true })
            /// Setting data in session storage For Insert Next
            this.props.delegateRegistrationGroupSubmit_action(agreeTerms)
                .then((data) => {
                    this.props.navigate('/delegatePreview', {
                        state: {
                            // ExhVisitorID: data.data[0]['ExhVisitorID'],
                            // countryID: countryId
                        }
                    })
                })
        } else {
            toastError("Please Agree to the terms")
        }
    }

    getDetails() {
        const { attendeeList, industryChapterList, GroupDetailsList, primaryChapterListData, primaryChapterListDataModal, level0Modal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal, countryList,
            stateList, turnOverList,
            cityList,
            pincodeList,
            genderList,
            gstValidtionList,
            chapterList, chapterListModal,
            visitorTypeList,
            visitPurposeList, visitPurposeListModal,
            interestList, B2bMeetingList,
            daysList, daysListModal, B2bMeetingListmodal,
            isLoading, arrivalDate, arrivalDateErr, agreeTerms, visitPurposeErr, departureDate, departureDateErr, ChapterHallErr, primaryChapterListLevel3, primaryChapterListLevel4, isInterestTwo, isInterestOne, needVisaAssistance, passName, passNameErr, applicantMobNo, applicantMobNoErr, preApplicantMobNo, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passExipryDate, passDateErr, passExipryDateErr, passCountry, passCountryErr, isPassportFilePresent, passportFileErr, passportFile, passPortFileName, passportFilePath, isVisaApplied, daysErr
        } = this.state
        // this.setState({ isLoading: true })
        this.props.getDelegateDetailsStep1_action(sessionStorage.getItem("DelegateTypeID"))
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    // var daysArr = []
                    console.log("daysListdaysListdaysList", daysList)
                    var selectedDaysList = data.data[4] != null ? data.data[4] : []
                    daysList.length > 0 && daysList.map((element) => {
                        selectedDaysList.length > 0 && selectedDaysList.map((element2) => {
                            if (moment(element2.VisitDate).format('DD MMM YYYY') == element.VisitDate) {
                                element.isSelect = true
                                // element.visitDay = element.VisitDate
                                // daysArr.push(element)
                            }
                        })
                    })
                    // var chapterListSelected = []
                    var selectedChapters = data.data[1] != null ? data.data[1] : []
                    chapterList.length > 0 && chapterList.map((element) => {
                        selectedChapters.length > 0 && selectedChapters.map((element2) => {
                            if (element2.IndustrySegmentID == element.IndustrySegmentID) {
                                element.isSelect = true
                                // element.ChapterID = element.IndustrySegmentID
                                // element.ChapterName = element['Industrial Segment']
                                // chapterListSelected.push(element)
                            }
                        })
                    })

                    // var purposeOfVisit = []
                    var selectedPurposeOfVisit = data.data[3] != null ? data.data[3] : []
                    visitPurposeList.length > 0 && visitPurposeList.map((element) => {
                        selectedPurposeOfVisit.length > 0 && selectedPurposeOfVisit.map((element2) => {
                            if (element2.PurposeofVisitID == element.PurposeofVisitID) {
                                element.isSelect = true
                                // purposeOfVisit.push(element)
                            }
                        })
                    })

                    // var hallList = []
                    var SelectedHallChapters = data.data[2] != null ? data.data[2] : []
                    primaryChapterListData.length > 0 && primaryChapterListData.map((element) => {
                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                            if (element2.MappingChapterID == element.ChapterID) {
                                element.isSelect = true
                                // hallList.push(element)
                            }
                        })
                    })
                    level2.length > 0 && level2.map((element) => {
                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {

                            if (element2.MappingChapterID == element.ChapterID) {
                                element.isSelect = true
                                //   hallList.push(element)
                            }
                        })
                    })
                    level3.length > 0 && level3.map((element) => {
                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {

                            if (element2.MappingChapterID == element.ChapterID) {
                                element.isSelect = true
                                //   hallList.push(element)
                            }
                        })
                    })
                    level4.length > 0 && level4.map((element) => {
                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {

                            if (element2.MappingChapterID == element.ChapterID) {
                                element.isSelect = true
                                //   hallList.push(element)
                            }
                        })
                    })

                    var selectedseminarList = data.data[5] != null ? data.data[5] : []
                    console.log(selectedseminarList, 'selectedDaysList', seminarInterestList)

                    seminarInterestList.length > 0 && seminarInterestList.map((element) => {
                        selectedseminarList.length > 0 && selectedseminarList.map((element2) => {
                            if (element2.SeminarID == element.SeminarID) {
                                element.isSelect = true
                                // seminarListSelected.push(element)
                            }
                        })
                    })

                    var selectedB2bList = data.data[6] != null ? data.data[6] : []

                    B2bMeetingList.length > 0 && B2bMeetingList.map((element) => {
                        element.timeSlotList.length > 0 && element.timeSlotList.map((inElement) => {
                            selectedB2bList.length > 0 && selectedB2bList.map((element2) => {
                                if (element2.B2BTimeSlotID == inElement.B2BTimeSlotID) {
                                    inElement.isSelect = true
                                    inElement.IsBooked = false
                                    // B2bListSelected.push({ B2BTimeSlotID: inElement.B2BTimeSlotID })
                                }
                            })
                        })
                    })

                    // B2bMeetingList.length > 0 && B2bMeetingList.map((element) => {
                    //     element.timeSlotList.length > 0 && element.timeSlotList.map((inElement) => {
                    //         selectedB2bList.length > 0 && selectedB2bList.map((element2) => {
                    //             if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                    //                 if (element2.B2BTimeSlotID == inElement.B2BTimeSlotID) {
                    //                     inElement.isSelect = true
                    //                     inElement.IsBooked = false
                    //                     B2bListSelected.push(element)
                    //                 }
                    //             }
                    //         })
                    //     })
                    // })

                    var mob5 = data.data[0][0]['ApplicantMobileNo'] ?? ''
                    const parts5 = mob5 != null ? mob5.split("-") : ''
                    const Mob5Code = parts5.length == 2 ? parts5[0] : ''
                    const Mob5No = parts5.length == 2 ? parts5[1] : mob5
                    var mob1 = data.data[0][0]['MobileNo']
                    const parts = mob1 != null ? mob1.split("-") : ''
                    const Mob1Code = parts.length == 2 ? parts[0] : ''
                    const Mob1No = parts.length == 2 ? parts[1] : mob1
                    var filePath = data.data[0][0].PassportFilePath != null ? data.data[0][0]['PassportFilePath'] : ''
                    var array = data.data[0][0]['PassportFilePath'] != null && data.data[0][0]['PassportFilePath'] != "" && filePath.split("/")
                    const FileName = array[array.length - 1]
                    this.setState({
                        chaptersList: chapterList,
                        seminarInterestList: seminarInterestList,
                        daysList: daysList,
                        visitPurposeList: visitPurposeList,
                        // industrySegmentList: chapterList,
                        level2: level2,
                        level3: level3,
                        level4: level4,
                        B2bMeetingList: B2bMeetingList,
                        primaryChapterListData: primaryChapterListData,
                        isInterestTwo: data.data[0][0].IsIntrestedForB2B ?? '',
                        // B2BmappingList: [],
                        IsIntrestedForB2B: data.data[0][0].IsIntrestedForB2B ?? '',

                        applicantEmail: data.data[0][0].ApplicantEmailID ?? '',
                        preApplicantMobNo: Mob5Code,
                        applicantMobNo: Mob5No,
                        mobNo: Mob1No,
                        preMobNo: Mob1Code,
                        email: data.data[0][0].PrimaryEmail ?? '',
                        passName: data.data[0][0].NameOnPassport ?? '',
                        passExipryDate: data.data[0][0].PassportExpiryDate != null && data.data[0][0].PassportExpiryDate != '1900-01-01T00:00:00.000Z' ? new Date(data.data[0][0].PassportExpiryDate) : null,
                        passPortFileName: FileName ?? '',
                        passportFile: data.data[0][0].PassportFilePath != null && data.data[0][0].PassportFilePath != '' ? FileName : '',
                        passportFilePath: data.data[0][0].PassportFilePath ?? '',
                        passportFileType: '',
                        passDate: data.data[0][0].PassportIssueDate != null && data.data[0][0].PassportIssueDate != '1900-01-01T00:00:00.000Z' ? new Date(data.data[0][0].PassportIssueDate) : null,
                        passCountry: data.data[0][0].PassportIssuingCountryID ?? '',
                        passNo: data.data[0][0].PassportNo ?? '',
                        needVisaAssistance: data.data[0][0].isVisaAssistance ?? '',
                        isSameAsMobNo: data.data[0][0].IsSameMobileNo ?? '',
                        isPassportFilePresent: data.data[0][0].PassportFilePath != null && data.data[0][0].PassportFilePath != '' ? true : false,
                        isVisaApplied: data.data[0][0].PassportFilePath != null && data.data[0][0].PassportFilePath != '' ? true : false,
                        agreeTerms: data.data[0][0].IsAgree,
                        countryId: data.data[0][0].CountryID,
                        isLoading: false,
                    })
                }
                setTimeout(() => {
                    console.log("7d7sd7sd7sd7sd", daysList)
                }, 500);
            })
    }

    getNotes() {
        const { attendeeList, industryChapterList, GroupDetailsList, primaryChapterListData, primaryChapterListDataModal, level0Modal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal, countryList,
            stateList, turnOverList,
            cityList,
            pincodeList,
            genderList,
            gstValidtionList,
            chapterList, chapterListModal,
            visitorTypeList,
            visitPurposeList, visitPurposeListModal,
            interestList,
            daysList, daysListModal, B2bMeetingListmodal,
            B2bMeetingList, note } = this.state
        // this.setState({ isLoading: true })
        this.props.getExhNoteDetails_action(sessionStorage.getItem('sessionExhibitionID'))
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    var notesArr = []
                    data.data.length > 0 && data.data.map(item => {
                        if (item.NoteType == 'Delegate Registration') {
                            notesArr.push(item.Description)
                        }
                    })
                    this.setState({ note: notesArr })
                }
            })
    }

    onSelectPrimaryChapter(e, status) {
        const { chapterList, chapterListModal } = this.state
        var id = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            chapterListModal.length > 0 && chapterListModal.map((data) => {
                if (checked) {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = true
                        if (id == 16) {
                            this.setState({ isOtherOpenModal: true })
                        }
                    }
                }
                else {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = false
                        if (id == 16) {
                            this.setState({ isOtherOpenModal: false })
                        }
                    }
                }
            })
            console.log("----", chapterList)
            this.setState({ chapterListModal: chapterListModal, chapterErrModal: "" })
        } else {
            chapterList.length > 0 && chapterList.map((data) => {
                if (checked) {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = true
                        if (id == 16) {
                            this.setState({ isOtherOpen: true })
                        }
                    }
                }
                else {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = false
                        if (id == 16) {
                            this.setState({ isOtherOpen: false })
                        }
                    }
                }
            })
            console.log("hgdddhdjdjdjdkdj", chapterList)
            this.setState({ chapterList: chapterList, chapterErr: "" })
        }
    }

    onSelectPurpose(e, status) {
        const { visitPurposeList, visitPurposeListModal } = this.state
        var code = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            visitPurposeListModal.length > 0 && visitPurposeListModal.map((data) => {
                if (checked) {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = true
                    }
                }
                else {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = false
                        data.otherDetail = ""
                    }

                }
            })
            console.log("hgdddhdjdjdjdkdj", visitPurposeListModal)
            this.setState({ visitPurposeListModal: visitPurposeListModal, visitPurposeErrModal: "" })
        } else {
            visitPurposeList.length > 0 && visitPurposeList.map((data) => {
                if (checked) {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = true
                    }
                }
                else {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = false
                        data.otherDetail = ""
                    }

                }
            })
            console.log("hgdddhdjdjdjdkdj", visitPurposeList)
            this.setState({ visitPurposeList: visitPurposeList, visitPurposeErr: "" })
        }
    }

    otherDetailsChange(e, status) {
        const { visitPurposeList, visitPurposeErr, visitPurposeListModal } = this.state
        var value = e.target.value
        if (status == 1) {
            visitPurposeListModal.length > 0 && visitPurposeListModal.map((data) => {
                if (data.PurposeofVisitID == 10 && data.isSelect) {
                    data.otherDetail = value
                } else {
                    data.otherDetail = ""
                }
            })
            this.setState({ visitPurposeListModal: visitPurposeListModal })
            console.log("sssssssssssssssssssssss", visitPurposeListModal)
        } else {
            visitPurposeList.length > 0 && visitPurposeList.map((data) => {
                if (data.PurposeofVisitID == 10 && data.isSelect) {
                    data.otherDetail = value
                } else {
                    data.otherDetail = ""
                }
            })
            this.setState({ visitPurposeList: visitPurposeList, visitPurposeErr: '' })
            console.log("sssssssssssssssssssssss", visitPurposeList)
        }
    }

    onCheckLevel2(e, id, tempLevel1) {
        const { level2, primaryChapterListLevel3, level2Modal, level3Modal, level4Modal, primaryChapterListLevel3Modal, primaryChapterListLevel4Modal, primaryChapterListDataModal, level3, primaryChapterListLevel4, primaryChapterListData, level4 } = this.state
        const event = e.target.checked
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {
                if (event == true) {
                    level2[i]['isSelect'] = true
                    this.setState({ ChapterHallErr: "" })

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.isSelect = true
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.isSelect = true
                                }
                            });
                        }
                    });

                } else {
                    level2[i]['isSelect'] = false

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.isSelect = false
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.isSelect = false
                                }
                            });
                        }
                    });
                }

            }
        }
        console.log("tempLevel1", tempLevel1)
        for (let i = 0; i < primaryChapterListData.length; i++) {
            for (let j = 0; j < level2.length; j++) {
                if (level2[j]['ChapterID'] == id) {
                    if (primaryChapterListData[i]['ChapterID'] == level2[j]['ParentChapterID']) {
                        const allSelectedChecked = tempLevel1.every(item => item.isSelect == 1)
                        console.log("allSelectedChecked", allSelectedChecked)
                        if (allSelectedChecked) {
                            primaryChapterListData[i]['isSelect'] = true
                        } else {
                            primaryChapterListData[i]['isSelect'] = false
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level2: level2 })
        }, 200);

    }

    recordTwo(level2, level3, level4) {
        const { primaryChapterListLevel3, primaryChapterListLevel3Modal } = this.state
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
                primaryChapterListLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} >
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed " type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={'#collapse_l2_' + level3data.ChapterID}
                                                aria-expanded="false"
                                                aria-controls={'collapse_l2_' + level3data.ChapterID}
                                            >
                                                {/* // checkbox for level3 */}
                                                {level3data.IsCheckbox &&
                                                    <input type="checkbox" className="from-left-sp"

                                                        name="" id={level3data.ChapterID} checked={level3data.isSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID, tempLevel3)} />
                                                }
                                                <label for={level3data.ChapterID} style={{ background: 'none', cursor: 'pointer', padding: 0 }}>
                                                    {level3data.ChapterName}
                                                </label></button>
                                        </h2>
                                        {this.recordThree(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );

    }

    onCheckLevel3(e, id, tempLevel3) {
        const { level2, primaryChapterListLevel3, level2Modal, level3Modal, level4Modal, primaryChapterListLevel3Modal, primaryChapterListLevel4Modal, primaryChapterListDataModal, level3, primaryChapterListLevel4, primaryChapterListData, level4 } = this.state
        // this.setState({ level4DummyId: id })
        const event = e.target.checked

        var modelevel2 = []
        var modelevel3 = []
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                console.log("***********", level3[i])
                level2.map((s) => {
                    if (level3[i].ParentChapterID == s.ChapterID) {
                        primaryChapterListData.map(q => {
                            if (s.ParentChapterID == q.ChapterID) {
                                modelevel3.push(q)
                            }
                        })
                    }
                })
            }
        }


        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })

        console.log("finalListlevel2", finalListlevel2)


        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                if (event == true) {
                    level3[i]['isSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {

                            level4.isSelect = true
                        }
                    });

                } else {
                    level3[i]['isSelect'] = false
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {
                            level4.isSelect = false
                        }
                    });

                }
            }
        }

        for (let i = 0; i < level3.length; i++) {
            for (let index = 0; index < level2.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    if (level3[i]['ChapterID'] == id) {
                        if (level2[index]['ChapterID'] == level3[i]['ParentChapterID']) {
                            if (primaryChapterListData[j]['ChapterID'] == level2[index]['ParentChapterID']) {
                                const allSelectedChecked = tempLevel3.every(item => item.isSelect == 1)
                                if (allSelectedChecked) {
                                    level2[index]['isSelect'] = true
                                    const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.isSelect == 1)
                                    console.log("allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                    if (allSelectedfinalListlevel2) {
                                        primaryChapterListData[j]['isSelect'] = true
                                    } else {
                                        primaryChapterListData[j]['isSelect'] = false
                                    }
                                }
                                else {
                                    level2[index]['isSelect'] = false
                                    primaryChapterListData[j]['isSelect'] = false
                                }
                            }
                        }
                    }
                }

            }

        }
        setTimeout(() => {
            this.setState({ level3: level3, level2: level2 })
        }, 100);

    }

    recordThree(level3data, level4) {
        const { primaryChapterListLevel4, primaryChapterListLevel4Modal } = this.state
        // console.log("level4", level4)
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
                primaryChapterListLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step" style={{ display: 'flex' }}>

                                {level4data.IsCheckbox &&
                                    <input type="checkbox" name="" id={level4data.ChapterID} checked={level4data.isSelect}
                                        onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID, tempLevel4)} />
                                }
                                <label for={level4data.ChapterID} style={{ background: 'none', cursor: 'pointer', padding: 0 }}>
                                    {level4data.ChapterName}
                                </label>
                            </div>
                        )
                    })
                }
            </div>
        </>);

    }

    onSelectLevel4(e, id, tempLevel4) {
        const { level2, primaryChapterListLevel3, level2Modal, level3Modal, level4Modal, primaryChapterListLevel3Modal, primaryChapterListLevel4Modal, primaryChapterListDataModal, level3, primaryChapterListLevel4, primaryChapterListData, level4 } = this.state
        var tempExhibitDetailsList = []
        { console.log('accordion') }

        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level4[i]['isSelect'] = !level4[i]['isSelect']
            }
        }
        this.setState({ ChapterHallErr: "" })
        var modelevel2 = []
        var modelevel3 = []

        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level3.map((s) => {
                    if (level4[i].ParentChapterID == s.ChapterID) {
                        level2.map(p => {
                            if (s.ParentChapterID == p.ChapterID) {
                                modelevel2.push(p)
                                primaryChapterListData.map(q => {
                                    if (p.ParentChapterID == q.ChapterID) {
                                        modelevel3.push(q)
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }

        const finalListlevel3 = []
        level3.map(data => {
            modelevel2.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel3.push(data)
                }

            })
        })

        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })

        console.log("************** finalListlevel2", finalListlevel2)
        // console.log("************** finalListlevel3", finalListlevel3)


        for (let i = 0; i < tempLevel4.length; i++) {
            for (let index = 0; index < level3.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    for (let k = 0; k < level2.length; k++) {
                        if (tempLevel4[i]['ChapterID'] == id) {
                            if (level3[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                                if (level2[k]['ChapterID'] == level3[index]['ParentChapterID']) {
                                    if (primaryChapterListData[j]['ChapterID'] == level2[k]['ParentChapterID']) {
                                        const allSelectedChecked = tempLevel4.every(item => item.isSelect == 1)
                                        if (allSelectedChecked) {
                                            level3[index]['isSelect'] = true

                                            const allSelectedfinalListlevel3 = finalListlevel3.every(item => item.isSelect == 1)
                                            if (allSelectedfinalListlevel3) {
                                                level2[k]['isSelect'] = true

                                                const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.isSelect == 1)
                                                console.log("************** allSelectedfinalListlevel2", allSelectedfinalListlevel2)
                                                if (allSelectedfinalListlevel2) {
                                                    primaryChapterListData[j]['isSelect'] = true

                                                } else {
                                                    primaryChapterListData[j]['isSelect'] = false
                                                }

                                            } else {
                                                level2[k]['isSelect'] = false
                                            }


                                        }
                                        else {
                                            level3[index]['isSelect'] = false
                                            level2[k]['isSelect'] = false
                                            primaryChapterListData[j]['isSelect'] = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level4: level4, level3: level3, level2: level2 })
        }, 100);

    }

    onSelectInterest(e, status) {
        const { interestList, daysList, interestListModal, isInterestTwo, B2bMeetingList, isInterestTwoModal } = this.state
        var code = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            this.setState({ isInterestTwoModal: !isInterestTwoModal })
        } else {
            this.setState({ isInterestTwo: !isInterestTwo })
            if (checked) {
                this.setState({ daysErr: false })
                for (var i = 0; i < daysList.length; i++) {
                    daysList[i].isSelect = false
                }
                this.setState({ daysList: daysList, b2bErr: '' })
            }
            else {
                for (var i = 0; i < B2bMeetingList.length; i++) {
                    for (var a = 0; a < B2bMeetingList[i].timeSlotList.length; a++) {
                        if (!B2bMeetingList[i].timeSlotList[a].IsBooked) {
                            B2bMeetingList[i].timeSlotList[a].isSelect = false
                        }
                    }
                }
                this.setState({ B2bMeetingList: B2bMeetingList, b2bErr: '' })
            }
        }
    }

    onSelect(id, status) {
        console.log(id, status)
        const { B2bMeetingList, B2bMeetingListmodal, daysList } = this.state
        if (status == 1) {
            console.log(id, '====================')

            for (var i = 0; i < B2bMeetingListmodal.length; i++) {
                for (var j = 0; j < B2bMeetingListmodal[i].timeSlotList.length; j++) {
                    if (id == B2bMeetingListmodal[i].timeSlotList[j].B2BTimeSlotID) {
                        if (B2bMeetingListmodal[i].timeSlotList[j].isSelect) {
                            B2bMeetingListmodal[i].timeSlotList[j].isSelect = false
                        }
                        else {
                            B2bMeetingListmodal[i].timeSlotList[j].isSelect = true
                        }
                    }
                }
            }
            console.log(B2bMeetingListmodal)
            this.setState({ B2bMeetingListmodal: B2bMeetingListmodal, b2bErrModal: '' })
        } else {
            console.log(id, '-////////////////////////////////')

            for (var i = 0; i < B2bMeetingList.length; i++) {
                for (var j = 0; j < B2bMeetingList[i].timeSlotList.length; j++) {
                    if (id == B2bMeetingList[i].timeSlotList[j].B2BTimeSlotID) {
                        if (B2bMeetingList[i].timeSlotList[j].isSelect) {
                            B2bMeetingList[i].timeSlotList[j].isSelect = false
                        }
                        else {
                            B2bMeetingList[i].timeSlotList[j].isSelect = true
                        }
                    }
                }
            }
            console.log(B2bMeetingList)
            this.setState({ B2bMeetingList: B2bMeetingList, b2bErr: '' })
        }
    }

    onFilePick = async (e, file, key, i) => {
        e.preventDefault()
        const { visitorGroupList } = this.state
        console.log("File01010101------", file, key)
        const { } = this.state
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                // else {
                this.setState({
                    passportFile: '',
                    passPortFileName: '',
                    passportFileType: '',
                    passportFilePath: '',
                })
                document.getElementById("passportFile").value = ""
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        //     visitorGroupList[i].passportFile = image
                        //     visitorGroupList[i].passportFileErr = ''
                        //     this.setState({ visitorGroupList: visitorGroupList })
                        // } else {
                        this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                        // }
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        //     visitorGroupList[i].passportFile = image
                        //     this.setState({ visitorGroupList: visitorGroupList })
                        // } else {
                        this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                        // }
                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    // }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                    // else {
                    this.setState({
                        passportFile: '',
                        passPortFileName: '',
                        passportFileType: '',
                        passportFilePath: '',
                    })
                    document.getElementById("passportFile").value = ""

                    // if (key == 1) {
                    //     this.setState({ passportFile: "" })
                    //     document.getElementById("passportFile").value = ""
                    // } else if (key == 2) {
                    //     this.setState({ visitorLetterFile: "" })
                    //     document.getElementById("visitorLetter").value = ""
                    // }
                }
            }
        }
        else {
            this.setState({
                passportFile: '',
                passPortFileName: '',
                passportFileType: '',
                passportFilePath: '',
            })
            document.getElementById("passportFile").value = ""
        }
    }

    // If Pdf is selected in file
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    // File resize
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    onCrossClick(key, mode) {
        const { passportFileType, isPassportFilePresent, passportFile, visitorGroupList } = this.state
        // i = i - 1
        // console.log(isPassportFilePresent, i + 1)
        // if (sessionStorage.getItem('VisitorTypeID') == 1) {
        console.log('isPassportFilePresent', isPassportFilePresent)
        if (isPassportFilePresent) {
            const { isOpen3 } = this.state
            this.setState({ isOpen3: !isOpen3 })
            console.log("condition------------1111111111")
        } else {
            console.log("condition------------2222222222")
            if (key == 1) {
                if (mode == 1) {
                    this.setState({ passportFile: "", isVisaApplied: false })
                } else {
                    this.setState({ passportFile: "", isVisaApplied: false })
                    document.getElementById("passportFile").value = ""
                }
            } else if (key == 2) {
                this.setState({ visitorLetterFile: "" })
                document.getElementById("visitorLetter").value = ""
            }
        }
        // }
        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
        //     if (isPassportFilePresent) {
        //         const { isOpen3 } = this.state
        //         this.setState({ isOpen3: !isOpen3, docDelAccountID: visitorGroupList[i].AccountID, docDelExhVisitorID: visitorGroupList[i].ExhVisitorID })
        //         console.log("condition------------1111111111")
        //     } else {
        //         console.log("condition------------2222222222")
        //         if (key == 1) {
        //             if (sessionStorage.getItem('VisitorTypeID') == 2) {
        //                 console.log(i + 1)
        //                 visitorGroupList[i].passportFile = ''
        //                 this.setState({ visitorGroupList: visitorGroupList })
        //                 document.getElementById(`path${i}`).value = ""
        //             } else {
        //                 this.setState({ passportFile: "" })
        //                 document.getElementById("passportFile").value = ""
        //             }
        //         } else if (key == 2) {
        //             this.setState({ visitorLetterFile: "" })
        //             document.getElementById("visitorLetter").value = ""
        //         }
        //     }
        // }
    }

    // onCheckedSeminar(e, id, status) {
    //     const { seminarInterestList, seminarInterestListModal } = this.state
    //     const checked = e.target.value
    //     if (status == 1) {
    //         seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => {
    //             if (data.SeminarID == id) {
    //                 if (data.isSelect) {
    //                     data.isSelect = false
    //                 } else {
    //                     data.isSelect = true
    //                 }
    //             }
    //         })
    //         console.log("aaaaaaaaaaa", seminarInterestListModal)
    //         // this.setState({isLoading})
    //         this.setState({ seminarInterestListModal: seminarInterestListModal, SeminarErrModal: '' })
    //     } else {
    //         seminarInterestList.length > 0 && seminarInterestList.map((data) => {
    //             if (data.SeminarID == id) {
    //                 console.log(e.target.value, data.isSelect, id)
    //                 if (data.isSelect) {
    //                     data.isSelect = false
    //                 } else {
    //                     data.isSelect = true
    //                 }
    //             }
    //         })
    //         console.log("aaaaaaaaaaa", seminarInterestList)
    //         this.setState({ seminarInterestList: seminarInterestList, SeminarErr: '' })
    //     }
    // }

    // On Checked seminar
    onCheckedSeminar(e, id) {
        const { seminarInterestList } = this.state
        const checked = e.target.checked
        if (checked != undefined) {
            seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                if (data.SeminarID == id) {
                    if (checked) {
                        data.isSelect = true
                    } else {
                        data.isSelect = false
                    }
                }
            })
        } else {
            seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                if (data.SeminarID == id) {
                    if (data.isSelect) {
                        data.isSelect = false
                    } else {
                        data.isSelect = true
                    }
                }
            })
        }
        console.log("aaaaaaaaaaa", e.target.checked, seminarInterestList)
        this.setState({ seminarInterestList: seminarInterestList })
    }

    onSelectDates(e, status) {
        const { daysList, daysListModal, daysErr, B2bMeetingList, daysErrModal } = this.state
        var code = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            daysListModal.length > 0 && daysListModal.map((data) => {
                if (checked) {
                    if (code == data.Code) {
                        data.isSelect = true
                    }
                } else {
                    if (code == data.Code) {
                        data.isSelect = false
                    }

                }
            })
            var selectedDays = daysListModal.filter(data => data.isSelect == true)
            var list = []
            selectedDays.map((data) => {
                var data = {
                    "visitDay": data.VisitDate
                }
                list.push(data)
            })
            console.log("hgdddhdjdjdjdkdj", daysList, this.state.daysModalList)
            this.setState({ daysListModal: daysListModal, daysErrModal: "" })
        } else {
            daysList.length > 0 && daysList.map((data) => {
                if (checked) {
                    if (code == data.Code) {
                        data.isSelect = true
                    }
                } else {
                    if (code == data.Code) {
                        data.isSelect = false
                    }

                }
            })
            var selectedDays = daysList.filter(data => data.isSelect == true)
            var list = []
            selectedDays.map((data) => {
                var data = {
                    "visitDay": data.VisitDate
                }
                list.push(data)
            })
            for (var j = 0; j < B2bMeetingList.length; j++) {
                for (var b = 0; b < B2bMeetingList[j].timeSlotList.length; b++) {
                    if (!B2bMeetingList[j].timeSlotList[b].IsBooked || B2bMeetingList[j].timeSlotList[b].isSelect) {
                        B2bMeetingList[j].timeSlotList[b].isSelect = false
                    }
                }
            }
            console.log("hgdddhdjdjdjdkdj", daysList, this.state.daysModalList)
            this.setState({ daysList: daysList, daysErr: "", B2bMeetingList: B2bMeetingList })
        }
    }

    handleFinalSubmit() {
        const { isLoading, arrivalDate, arrivalDateErr, chapterList, agreeTerms, visitPurposeErr, departureDate, departureDateErr,
            passportFileType, IsIntrestedForB2B,
            visitPurposeList, ChapterHallErr, level2, level3, level4, primaryChapterListData, primaryChapterListLevel3, primaryChapterListLevel4, isInterestTwo, isInterestOne, B2bMeetingList, daysList, needVisaAssistance, passName, passNameErr, applicantMobNo, applicantMobNoErr, preApplicantMobNo, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passExipryDate, passDateErr, passExipryDateErr, passCountry, countryList, passCountryErr, isPassportFilePresent, passportFileErr, other, showFieldList, passportFilePath, passportFile, passPortFileName, seminarInterestList, isVisaApplied, daysErr
        } = this.state
        var Err = true
        const selectedChapter = chapterList.filter(data => data.isSelect == true)
        var chapterListData = []
        selectedChapter.map((data) => {
            var data = {
                "ChapterID": data.IndustrySegmentID,
                "ChapterName": data['Industrial Segment'],
                "OtherNames": data.IndustrySegmentID == 16 ? other : ''
            }
            chapterListData.push(data)
        })
        if (chapterListData.length == 0 && this.showMandatoryFields(30, 0) && this.showMandatoryFields(30, 2)) {
            this.setState({ chapterErr: "Please select industry segment" })
            Err = false
        }

        const purposeOfVisitlist = visitPurposeList.filter(data => data.isSelect == true)
        var purposeOfVisitlistData = []
        purposeOfVisitlist.map((data) => {
            var data = {
                "PurposeofVisitID": data.PurposeofVisitID,
                "OtherDetails": data.otherDetail
            }
            purposeOfVisitlistData.push(data)
        })
        var otherPOV = false
        purposeOfVisitlistData.map((data) => {
            otherPOV = data.PurposeofVisitID == 10 && data.OtherDetails == '' || data.OtherDetails == null ? true : false
            console.log('datadatadata', data)
            // var data = {
            //     "PurposeofVisitID": data.PurposeofVisitID,
            //     "OtherDetails": data.otherDetail
            // }
            // purposeOfVisitlistData.push(data)
        })
        console.log('datadatadata', otherPOV)
        if (otherPOV && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)) {
            console.log("purposeOfVisitlistData")
            this.setState({ visitPurposeErr: "Please enter other purpose of visit" })
            Err = false
        }
        if (purposeOfVisitlistData.length == 0 && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)) {
            this.setState({ visitPurposeErr: "Please select Purpose of visit" })
            Err = false
        }

        const selectedSeminarList = seminarInterestList.filter(data => data.isSelect == true)
        var seminarInterestListData = []
        selectedSeminarList.map((data) => {
            var data = {
                "SeminarID": data.SeminarID,
            }
            seminarInterestListData.push(data)
        })
        if (seminarInterestListData.length == 0 && this.showMandatoryFields(36, 0) && this.showMandatoryFields(36, 2)) {
            this.setState({ SeminarErr: "Please select Seminar" })
            Err = false
        }

        var selectedDays = []
        selectedDays = daysList.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        if (list.length == 0 && !isInterestTwo && this.showMandatoryFields(34, 0) && this.showMandatoryFields(34, 2)) {
            this.setState({ daysErr: "Please select Visit Days" })
            Err = false
        }

        var B2bList = []
        // B2bList = B2bMeetingListmodal.filter(data => data.isSelect == true)
        B2bMeetingList.length > 0 && B2bMeetingList.map(data => {
            data.timeSlotList.map(item => {
                if (item.isSelect) {
                    B2bList.push(item)
                }
            })
        })
        var B2bListfinal = []
        B2bList.length > 0 && B2bList.map(data => {
            var item = {
                "B2BTimeSlotID": data.B2BTimeSlotID
            }
            B2bListfinal.push(item)
        })
        if (B2bListfinal.length == 0 && isInterestTwo && this.showMandatoryFields(33, 0) && this.showMandatoryFields(33, 2)) {
            this.setState({ b2bErr: "Please select B2B time" })
            Err = false
        }

        var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        var chapterListData2 = []
        filerArray.map((data) => {
            var data = {
                "ChapterID": data.ChapterID,
                "ChapterName": data.ChapterName,
                // "OtherNames": ''

            }
            chapterListData2.push(data)
        })
        if (chapterListData2.length == 0 && this.showMandatoryFields(32, 0) && this.showMandatoryFields(32, 2)) {
            this.setState({ ChapterHallErr: "Please select Products" })
            Err = false
        }
        // if (this.showMandatoryFields(35, 0) && this.showMandatoryFields(35, 2) && !needVisaAssistance) {
        //     console.log("visaErr")
        //     this.setState({ visaErr: "Please select Visa Assistance" })
        //     Err = false
        // }
        var visaErr = false

        if (needVisaAssistance) {
            if (passName == "") {
                this.setState({ passNameErr: "Please enter Name " });
                visaErr = true
                Err = false
            }
            if (applicantMobNo == "") {
                this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
                visaErr = true
                Err = false
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email " });
                visaErr = true
                Err = false
            }

            if (passNo == "") {
                this.setState({ passNoErr: "Please enter Passport No " });
                visaErr = true
                Err = false
            }
            if (passDate == "" || passDate == null) {
                this.setState({ passDateErr: "Please enter Passport Date " });
                visaErr = true
                Err = false
            }
            if (passExipryDate == null || passExipryDate == "") {
                this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
                visaErr = true
                Err = false
            }
            if (passCountry == "") {
                this.setState({ passCountryErr: "Please Select Country " });
                visaErr = true
                Err = false
            }
            if (passportFile == "") {
                this.setState({ passportFileErr: "Please Upload File " });
                visaErr = true
                Err = false
            }
            if (applicantEmail != "") {
                var emailError = emailValidator(applicantEmail)
                if (emailError != '') {
                    this.setState({ applicantEmailErr: emailError })
                    return
                }
            }
            if (visaErr) {
                if (this.showMandatoryFields(35, 0) && this.showMandatoryFields(35, 2)) {
                    this.setState({ visaErr: "Please Fill Visa Assistance" })
                    Err = false
                }
            } else {
                this.setState({ visaErr: "" })
            }
        }
        setTimeout(() => {
            if (Err) {
                var agreeTermsErr = true
                if (!agreeTerms && this.showMandatoryFields(29, 2)) {
                    agreeTermsErr = false
                }
                if (agreeTermsErr) {
                    this.setState({ isLoading: true })
                    /// Setting data in session storage For Insert Next
                    this.props.delegateRegistrationSubmit_action(this.state.AccountID, this.state.DelegateRegistrationID, this.state.isInterestTwo, needVisaAssistance, passName, needVisaAssistance ? applicantEmail : '', needVisaAssistance ? `${preApplicantMobNo}-${applicantMobNo}` : '', passNo, passDate, passExipryDate, passCountry, passportFilePath, passportFile, passPortFileName, passportFileType, chapterListData, purposeOfVisitlistData, selectedDays, seminarInterestListData, filerArray, B2bListfinal, agreeTerms)
                        .then((data) => {
                            if (data.error != 1) {
                                this.props.navigate('/delegatePreview', {
                                    state: {
                                        // ExhVisitorID: data.data[0]['ExhVisitorID'],
                                        // countryID: countryId
                                    }
                                })
                            } else {
                                this.setState({ isLoading: false })
                                // console.log
                                toastError(data.msg);
                            }
                        }).catch((err) => {
                            console.log(err)
                        })
                } else {
                    toastError("please accept rules & regulations")
                }

            } else {
                toastError("please enter mandatory fields")
            }
        }, 200);
    }

    // Email Verify after Input
    verifyEmail(e, status) {
        var value = e.target.value
        if (value != "") {
            var emailError = emailValidator(value)
            if (emailError != '') {
                status == 1 ? this.setState({ emailErrModal: emailError }) : this.setState({ emailErr: emailError })
                return
            } else {
                this.setState({ isLoading: true })
                this.props.verifyVisitorEmail_action(value, JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false })
                            if (data.data['ErrMsg'] != "" && data.data['ErrMsg'] != null) {
                                status == 1 ? this.setState({ emailErrModal: data.data['ErrMsg'] }) : status == 2 ? this.setState({ applicantEmailErr: data.data['ErrMsg'] }) : status == 3 ? this.setState({ applicantEmailErrModal: data.data['ErrMsg'] }) : this.setState({ emailErr: data.data['ErrMsg'] })
                            } else {
                                status == 1 ? this.setState({ emailErrModal: '' }) : status == 2 ? this.setState({ applicantEmailErr: '' }) : status == 3 ? this.setState({ applicantEmailErrModal: '' }) : this.setState({ emailErr: "" })
                            }
                        } else {
                            this.setState({ isLoading: false })
                            status == 1 ? this.setState({ emailErrModal: '' }) : status == 2 ? this.setState({ applicantEmailErr: '' }) : status == 3 ? this.setState({ applicantEmailErrModal: '' }) : this.setState({ emailErr: "" })
                        }

                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }


        } else {
            status == 1 ? this.setState({ emailErrModal: "Please enter Email" }) : status == 2 ? this.setState({ applicantEmailErr: "Please enter Email" }) : status == 3 ? this.setState({ applicantEmailErrModal: "Please enter Email" }) : this.setState({ emailErr: "Please enter Email" })
        }
    }

    onCountrySelect(e, status) {
        const { countryList } = this.state
        var countryId = e.target.value
        if (countryId != '') {
            if (status == 1) {
                this.setState({ countryIdModal: countryId, countryIdErrModal: "" })
                var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                this.setState({
                    preMobNoModal: `+${countryCode}`,
                    preWhatsAppMobNoModal: `+${countryCode}`,
                    preApplicantMobNoModal: `+${countryCode}`
                })
                this.getFillList(pincodeActionId, '', '', countryId, '', '')
                this.getFillList(stateActionId, '', '', countryId, '', '')
                this.getFillList(cityActionId, '', '', countryId, '', '')
            } else if (status == 2) {
                this.setState({ passCountry: countryId, passCountryErr: "", passCountryErr: '' })
                // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                // this.setState({
                //     preMobNo: `+${countryCode}`,
                //     preWhatsAppMobNo: `+${countryCode}`
                // })
            } else if (status == 3) {
                // this.setState({ delegationCountry: countryId, delegationCountryErr: "" })
                this.setState({ passCountryModal: countryId, passCountryErrModal: "" })
                // var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                // this.setState({
                //     preMobNo: `+${countryCode}`,
                //     preWhatsAppMobNo: `+${countryCode}`
                // })
            } else {
                this.setState({ countryId: countryId, countryIdErr: "" })
                var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                this.setState({
                    preMobNo: `+${countryCode}`,
                    preWhatsAppMobNo: `+${countryCode}`,
                    preApplicantMobNo: `+${countryCode}`
                })
                // Calling City , State , Pincode filllist on country Select
                this.getFillList(pincodeActionId, '', '', countryId, '', '')
                this.getFillList(stateActionId, '', '', countryId, '', '')
                this.getFillList(cityActionId, '', '', countryId, '', '')
            }
            setTimeout(() => {
                this.setState({
                    isDisplayPincodeList: false,
                    isDisplayCityList: false,
                    isDisplayStateList: false,
                    isDisplayPincodeListModal: false,
                    isDisplayCityListModal: false,
                    isDisplayStateListModal: false,
                })
            }, 200);
        }
    }

    handleDelete(e) {
        e.preventDefault()
        const { isOpen3, docDelAccountID, docDelExhVisitorID, ExhVisitorIDModal, GroupDetailsList, AccountIDModal, modalID, PassportFileCoordinator, PassportFileNameCoordinator, AccountTypeID, onCrossClickFlagCoordinator, PassportFileTypeCoordinator, DelegateRegistrationID, DelegateRegistrationIDModal, isPassportFilePresentCoordinator, passportFilePathCoordinator, passportFile, passportFilePath, isVisaApplied, passportFileType, passPortFileName, isPassportFilePresent, AccountID, visitorGroupList } = this.state
        this.setState({ isLoading: true })
        this.props.deleteVisaDoc_action(AccountTypeID, AccountID, DelegateRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Passport Document Deleted SuccessFully")
                    // sessionStorage.getItem('VisitorTypeID') == 1 && this.setState({ passportFile: "", passPortFileName: "", isPassportFilePresent: false })
                    // if (onCrossClickFlagCoordinator) {
                    this.setState({ passportFile: '', isVisaApplied: false, passportFileType: '', passPortFileName: '', isPassportFilePresent: false, passportFilePath: '' })
                    // } else {
                    //     GroupDetailsList.map(item => {
                    //         console.log(AccountIDModal, item, item.AccountID)
                    //         if (item.AccountID == AccountIDModal) {
                    //             item.PassportFile = ''
                    //             item.PassportFileType = ''
                    //             item.PassportFileName = ''
                    //             item.passportFilePath = ''
                    //             item.isPassportFilePresent = false
                    //             item.isVisaApplied = false
                    //         }
                    //     })
                    //     this.setState({ passportFileModal: '', isVisaAppliedModal: false, passportFileTypeModal: '', passPortFileNameModal: '', isPassportFilePresentModal: false, passportFilePathModal: '' })
                    // }
                    this.setState({ isLoading: false, isOpen3: false })
                    // sessionStorage.getItem('VisitorTypeID') == 2 && this.setState({ visitorGroupList: visitorGroupList })
                    // this.getVisitorRegistrationDetails()
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    showMandatoryFields(FieldID, mode) {
        const { showFieldList } = this.state
        var isFieldAvailable = false
        for (var i = 0; i < showFieldList.length; i++) {
            // console.log(showFieldList[i], FieldID)
            if (showFieldList[i].id == FieldID) {
                isFieldAvailable = true
                if (mode == 0) {
                    return true
                } else if (mode == 1) {
                    return showFieldList[i].name
                } else if (mode == 2) {
                    if (showFieldList[i].mandatory) {
                        return true
                    } else {
                        return false
                    }
                }
            }
        }
        if (!isFieldAvailable) {
            return false
        }
    }

    render() {
        const { isLoading, arrivalDate, arrivalDateErr, chapterList, agreeTerms, visitPurposeErr, departureDate, departureDateErr,
            visitPurposeList, ChapterHallErr, level2, level3, level4, primaryChapterListData, primaryChapterListLevel3, primaryChapterListLevel4, isInterestTwo, isInterestOne, B2bMeetingList, daysList, needVisaAssistance, passName, passNameErr, applicantMobNo, applicantMobNoErr, preApplicantMobNo, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passExipryDate, passDateErr, passExipryDateErr, passCountry, countryList, passCountryErr, isPassportFilePresent, showFieldList, passportFileErr, passportFile, passPortFileName, passportFilePath, seminarInterestList, isVisaApplied, daysErr
        } = this.state
        const allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        const filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        console.log(sessionStorage.getItem('DelegateTypeID'), "sessionStorage.getItem('DelegateTypeID')", showFieldList, this.showMandatoryFields(30, 0))
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && <HeaderWithLogo />}
                {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && <AdminDrawer />}
                {/* {console.log(!isLinkOpen)} */}
                <div className={!JSON.parse(sessionStorage.getItem('isLinkOpen')) && 'main-content app-content with-dr-container'} style={{ marginTop: '5rem' }}>
                    < VisitorHeader />
                    <div
                        className="main-content app-content mt-0"
                        style={{ marginInlineStart: 0 }}
                    >
                        <div className="side-app">
                            <div className="container-fluid p-0">
                                <div className="row" style={{ marginLeft: '0.3rem' }}>
                                    <div className="step-name">
                                        <p>{this.state.accountTypeList.length > 0 && this.state.accountTypeList.find(obj => obj.AccountTypeID == this.state.AccountTypeID)?.Name?.split(' ')[0]} Registration Form</p>
                                    </div>
                                </div>
                            </div>
                            <div className="needs-validation after-step mt-1">
                                <div id="Menu1">
                                    <div id="section-1">
                                        {
                                            sessionStorage.getItem('DelegateTypeID') != 10 && this.showMandatoryFields(30, 0) &&
                                            <div className="one-section mt-2">
                                                <div className="containerfluid">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">Industry Segment{this.showMandatoryFields(30, 2) && <span className="text-red">*</span>}
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.chapterErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=" mb-2">
                                                    <div className="row mt-1">
                                                        <div className="asc">
                                                            <div className="" style={{ paddingLeft: 10 }}>
                                                                <form className="needs-validation pb-2" noValidate="">
                                                                    <div className="form-row mt-3">
                                                                        {
                                                                            chapterList.length > 0 && chapterList.map((data) => (
                                                                                <div className="col-sm-3 mb-3">
                                                                                    <section className="" key={data.IndustrySegmentID}>
                                                                                        {/* <input type="checkbox" name="collapse"
                                                                                select={data.isSelect} checked={data.IndustrySegmentID}
                                                                                value={data.IndustrySegmentID}
                                                                            /> */}
                                                                                        <h2 className="handle-no-icon m-0" style={{ fontSize: '13px' }}>
                                                                                            <label style={{ color: '#666' }}>
                                                                                                <input type="checkbox"
                                                                                                    select={data.isSelect} checked={data.isSelect}
                                                                                                    value={data.IndustrySegmentID}
                                                                                                    onChange={(e) => this.onSelectPrimaryChapter(e)} />
                                                                                                {data['Industrial Segment']}
                                                                                            </label>
                                                                                        </h2>
                                                                                        {data.IndustrySegmentID == 16 && this.state.isOtherOpen && <input type="text" className="form-control" value={this.state.other}
                                                                                            // style={{ marginRight: "50px" }}
                                                                                            // maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                            // onPaste={(e) => this.handlePaste(e)}
                                                                                            // onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                                            onChange={(e) =>
                                                                                                this.setState({ other: e.target.value, })}
                                                                                        />}
                                                                                    </section>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                        {sessionStorage.getItem('DelegateTypeID') != 10 &&
                                            this.showMandatoryFields(31, 0) &&
                                            <div className="one-section mt-2">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Purpose of Visit{this.showMandatoryFields(31, 2) && <span className="text-red">*</span>}
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{visitPurposeErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-4">
                                                        {
                                                            visitPurposeList.length > 0 && visitPurposeList.map((data) => (
                                                                <div className="col-sm-3 mb-2" key={data.PurposeofVisitID}>
                                                                    <label className="d-flex">
                                                                        <input type="checkbox" name="fav_language"
                                                                            select={data.isSelect} checked={data.isSelect}
                                                                            value={data.PurposeofVisitID}
                                                                            onChange={(e) => this.onSelectPurpose(e)}
                                                                        />
                                                                        {data.PurposeofVisitName}
                                                                    </label>
                                                                    {
                                                                        data.PurposeofVisitID == 10 && data.isSelect &&
                                                                        <input
                                                                            className="form-control"
                                                                            maxLength={'100'}
                                                                            value={data.otherDetail}
                                                                            onChange={(e) => this.otherDetailsChange(e)}
                                                                        >
                                                                        </input>
                                                                    }
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>}
                                        {sessionStorage.getItem('DelegateTypeID') != 10 &&
                                            this.showMandatoryFields(32, 0) &&
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Products{this.showMandatoryFields(32, 2) && <span className="text-red">*</span>}
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{ChapterHallErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 mb-4">
                                                    <div className="row mt-4">
                                                        <div class="accordion" id="accordionExample">
                                                            {
                                                                level2.length > 0 && level2.map(level2Data => (
                                                                    <>
                                                                        {
                                                                            // level2Data.ParentChapterID == primaryChapterRadio &&
                                                                            <div class="accordion-item">
                                                                                <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                                    <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter" : "accordion-button collapsed"}
                                                                                        type="button" data-bs-toggle="collapse"
                                                                                        data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                        aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                        {/* // checkbox for level2 */}
                                                                                        {
                                                                                            level2Data.IsCheckbox &&
                                                                                            <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                                                                                checked={level2Data.isSelect}
                                                                                                onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                                                                        }
                                                                                        {level2Data.ChapterName} </button>
                                                                                </h2>
                                                                                {this.recordTwo(level2Data, level3, level4)}
                                                                            </div>
                                                                        }

                                                                    </>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="" style={{ marginLeft: "10px" }}>
                                                    <p className="mb-0" style={{ fontSize: 15 }}>
                                                        <strong>Selected Products</strong>
                                                    </p>
                                                </div>
                                                <div style={{ padding: "0px 0px 0px 10px" }}>
                                                    {
                                                        filerArray.length > 0 ? filerArray.map((data) => (
                                                            <p>
                                                                {data.ChapterName}
                                                            </p>
                                                        )) :
                                                            <p>
                                                                {"No Results"}
                                                            </p>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {sessionStorage.getItem('DelegateTypeID') != 10 &&
                                            <div className="one-section">
                                                {this.showMandatoryFields(33, 0) && <>
                                                    <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        B2B meetings
                                                                        {isInterestTwo && this.showMandatoryFields(33, 2) && <span className="text-red">*</span>}
                                                                        {/* {!isExhibitionFree && <span
                                                                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                                                                    // style={{ textAlign: 'right', right: '20px', position: 'absolute', cursor: 'pointer' }} 
                                                                                    className="mb-0 text-danger"
                                                                                    onClick={() => this.setState({ isOpen4: true })}>
                                                                                    Visit days Charges
                                                                                </span>} */}
                                                                    </p>
                                                                    {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.b2bErr}</span>}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            {/* {data.status && */}
                                                            <div className="col-sm-12 mt-2 mb-2" >
                                                                <label className="d-flex">
                                                                    <input type="checkbox" name="fav_language"
                                                                        select={isInterestTwo} checked={isInterestTwo}
                                                                        onChange={(e) => this.onSelectInterest(e)}
                                                                    />
                                                                    Interested to take part in B2B meetings
                                                                </label>
                                                                {isInterestTwo &&
                                                                    <>
                                                                        <div className="col-md-12">
                                                                            <div className="table-responsive" >
                                                                                <table className="table border table-bordered mb-0 mt-1" >
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th className="text-center" style={{ width: '150px' }}>Date</th>
                                                                                            <th className="text-center" style={{ width: '200px' }}>Location</th>
                                                                                            <th className="text-center">TimeSlots</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            B2bMeetingList.length > 0 && B2bMeetingList.map((data) => (
                                                                                                <tr key={Math.random()}>
                                                                                                    {data.rowSpan != 0 ? <td rowSpan={data.rowSpan} className="text-center" >{moment(data.B2BDate).format('DD MMM YYYY')}</td> : <></>}
                                                                                                    <td className="text-center" >{data.B2BLocation}</td>
                                                                                                    <td>
                                                                                                        <div className="form-row m-2">
                                                                                                            {data.timeSlotList.length > 0 && data.timeSlotList.map((item) => (

                                                                                                                <div className='col-sm-3 mt-1 mb-1'>
                                                                                                                    <ToggleButton
                                                                                                                        // size="sm"
                                                                                                                        // size={'10px'}
                                                                                                                        className={`p-2 rounded-5 ${item.IsBooked && 'text-white'} `}
                                                                                                                        id={item.B2BTimeSlotID}
                                                                                                                        type="checkbox"
                                                                                                                        variant={!item.IsBooked ? "outline-primary" : "outline-secondary"}
                                                                                                                        disabled={item.IsBooked}
                                                                                                                        checked={item.isSelect || item.IsBooked}
                                                                                                                        value={item.B2BTimeSlotID}
                                                                                                                        onClick={(e) => this.onSelect(item.B2BTimeSlotID)}
                                                                                                                    >
                                                                                                                        {item.timeslot}
                                                                                                                    </ToggleButton>
                                                                                                                </div>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))
                                                                                        }
                                                                                    </tbody>
                                                                                </table>

                                                                                <div />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>}
                                                {!isInterestTwo && this.showMandatoryFields(34, 0) &&
                                                    <div className="one-section">
                                                        <div className="containerfluid">
                                                            <div className="row mt-2">
                                                                <div className="col-md-12">
                                                                    <div className="p-1 title-bg d-flex">
                                                                        <p className="mb-0">
                                                                            Date of Visit Single Day Pass / All Day Pass{" "}
                                                                            {!isInterestTwo && this.showMandatoryFields(34, 2) && <span className="text-red">*</span>}
                                                                            {/* {!isExhibitionFree && <span
                                                                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                                                                    // style={{ textAlign: 'right', right: '20px', position: 'absolute', cursor: 'pointer' }} 
                                                                                    className="mb-0 text-danger"
                                                                                    onClick={() => this.setState({ isOpen4: true })}>
                                                                                    Visit days Charges
                                                                                </span>} */}
                                                                        </p>
                                                                        {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{daysErr}</span>}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div><div className="col-xl-4 mb-4">
                                                            <div className="row mt-4" >
                                                                {
                                                                    daysList.length > 0 && daysList.map((data) => (
                                                                        <div className="col-sm-4" key={data.Code}>
                                                                            <label className="d-flex">
                                                                                <input type="checkbox" select={data.isSelect}
                                                                                    checked={data.isSelect} value={data.Code}
                                                                                    onChange={(e) => this.onSelectDates(e)}
                                                                                />
                                                                                {data.VisitDate}
                                                                            </label>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>}
                                            </div>
                                        }
                                        {!(parseInt(this.state.countryId) == parseInt(sessionStorage.getItem('ExhibitionCountryID'))) && sessionStorage.getItem('DelegateTypeID') != 10 && this.showMandatoryFields(35, 0) &&
                                            <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Visa Application
                                                                    {needVisaAssistance && this.showMandatoryFields(35, 2) && <span className="text-red">*</span>}
                                                                    {/* {!isExhibitionFree && <span
                                                                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                                                                    // style={{ textAlign: 'right', right: '20px', position: 'absolute', cursor: 'pointer' }} 
                                                                                    className="mb-0 text-danger"
                                                                                    onClick={() => this.setState({ isOpen4: true })}>
                                                                                    Visit days Charges
                                                                                </span>} */}
                                                                </p>
                                                                {this.showMandatoryFields(35, 2) && <span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.visaErr}</span>}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-sm-12 ">
                                                    <div className="row mt-2">
                                                        <label className="d-flex">
                                                            <input type="checkbox" name="fav_language"
                                                                select={needVisaAssistance} checked={needVisaAssistance}
                                                                onChange={(e) => this.setState({
                                                                    needVisaAssistance: !needVisaAssistance,
                                                                    applicantMobNo: applicantMobNo != '' && applicantMobNo != null ? applicantMobNo : this.state.mobNo,
                                                                    applicantEmail: applicantEmail != '' && applicantEmail != null ? applicantEmail : this.state.email,
                                                                    preApplicantMobNo: preApplicantMobNo != '' && preApplicantMobNo != null ? preApplicantMobNo : this.state.preMobNo,
                                                                    visaErr: ''
                                                                })}
                                                            />
                                                            Do you need Visa Assistance?
                                                        </label>
                                                    </div>
                                                </div>
                                                {
                                                    needVisaAssistance &&
                                                    <div
                                                        className="col-md-12 mb-2"
                                                        id="divMsg"
                                                    >
                                                        <div className="row">
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Name as per Passport<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={passName} maxLength={'50'}
                                                                    onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ passName: e.target.value, passNameErr: '' })}
                                                                // onChange={(e) => /^[A-Za-z\s]+$/.test(e.target.value) ? this.setState({ passName: e.target.value, passNameErr: "" }) : null}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passNameErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Applicant mobile number<span className="text-red">*</span>
                                                                </label>

                                                                <div className="phone-input-group">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control phone-code mt-2" autoComplete="off" placeholder="ISD" readOnly
                                                                        // placeholder="ISD"
                                                                        maxLength={'4'} value={preApplicantMobNo}
                                                                        maxLength={'10'}
                                                                    />
                                                                    <input type="text" className="form-control phone-no" value={applicantMobNo}
                                                                        maxLength={this.state.countryId == 91 ? '10' : '11'}
                                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                        onPaste={(e) => this.handlePaste(e)}
                                                                        onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
    
                                                                        onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: '' }) : null}
                                                                    // onChange={(e) => e.target.value >= 0 &&
                                                                    //     this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: "" })}
                                                                    />
                                                                </div>
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{applicantMobNoErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Applicant email id<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={applicantEmail} maxLength={'50'}
                                                                    onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "" })}
                                                                    onBlur={(e) => this.verifyEmail(e, 2)}
                                                                />

                                                                {<span className='text-danger text-start text-left d-block mt-1'>{applicantEmailErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport No
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={passNo} maxLength={'10'}
                                                                    onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passNoErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport issue Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={passDate}
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            passDateErr: ""
                                                                        })}
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    maxDate={passExipryDate}
                                                                    dropdownMode="select"
                                                                    placeholderText="Passport Issued Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passDateErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport Expiry Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={passExipryDate}
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            passExipryDateErr: ""
                                                                        })}
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    minDate={passDate}
                                                                    dropdownMode="select"
                                                                    placeholderText="Passport Expiry Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{passExipryDateErr}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <div className="d-flex">
                                                                    <label className="mt-3 w-auto" >
                                                                        Passport issuing Country
                                                                        <span className="text-red">*</span>

                                                                    </label>
                                                                </div>
                                                                <select className="form-control" value={passCountry}
                                                                    onChange={(e) => this.onCountrySelect(e, 2)}
                                                                >
                                                                    <option>Select Your Country</option>
                                                                    {
                                                                        countryList.length > 0 && countryList.map((data) => (
                                                                            <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                {<span className='text-danger text-start text-left d-block '>{passCountryErr}</span>}

                                                            </div>
                                                            {/* <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={passCountry}
                                                            onChange={(e) => this.onPassportCountrySearch(e)}
                                                        />
                                                        {isDisplayPassCountryList && this.renderPassCountryList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{ }</span>}
                                                    </div> */}
                                                            {!(isPassportFilePresent) && !isVisaApplied &&
                                                                < div className="col-xl-12">
                                                                    <label className="mt-3">
                                                                        Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                        <span className="text-red">*</span>
                                                                        {<span className='text-danger text-start text-left ms-3 mt-1'>{passportFileErr}</span>}
                                                                    </label>
                                                                    <form action="/action_page.php" style={{ position: 'relative', textAlign: 'left' }}>
                                                                        <input type="file" id="passportFile" name="filename"
                                                                            accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                            onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                        />
                                                                        {
                                                                            passportFile != "" &&
                                                                            <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1)}></i>
                                                                        }
                                                                    </form>
                                                                </div>
                                                            }
                                                            {
                                                                isVisaApplied && passportFile != "" && passportFile != null &&
                                                                <div className="col-xl-12">
                                                                    <label className="mt-3">
                                                                        Passport Front Page File
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <div style={{
                                                                        border: '1px solid #ccc',
                                                                        padding: '10px',
                                                                        // display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        marginTop: '10px',
                                                                        // marginLeft: '12px',
                                                                        maxWidth: '300px'
                                                                    }}>
                                                                        <span style={{ marginRight: '10px' }}
                                                                        >{this.state.passPortFileName}</span>
                                                                        <i className="fa fa-times text-danger img-can" onClick={() => this.onCrossClick(1, 1)}></i>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            sessionStorage.getItem('DelegateTypeID') != 10 &&
                                            this.showMandatoryFields(36, 0) &&
                                            <div className="one-section">
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="containerfluid">
                                                            <div className="row mt-2">
                                                                {/* <div className="col-md-12"> */}
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Seminar
                                                                    </p>
                                                                    {this.showMandatoryFields(36, 2) && <span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.SeminarErr}</span>}
                                                                    {/* </div> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-md-12">
                                                    <div className="table-responsive" >
                                                        <table className="table border table-bordered mb-0 mt-1" >
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center" style={{ width: '100px' }}>Day</th>
                                                                    <th style={{ width: '350px' }}>Date & Time</th>
                                                                    <th >Session Name</th>
                                                                    {/* <th style={{ width: '400px' }}>Description</th>
                                                                                                <th style={{ width: '400px' }}>Speaker</th> */}
                                                                    <th style={{ width: '250px' }} className="text-center">Info</th>
                                                                    <th style={{ width: '250px' }} className="text-center">Register</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    seminarInterestList.length > 0 && seminarInterestList.map((data) => (
                                                                        <>
                                                                            {data.ParentSeminarID == 0 || data.ParentSeminarID == null && <tr >
                                                                                <td style={{ borderRight: 'none' }}></td>
                                                                                <td style={{ border: 'none' }}></td>
                                                                                <td style={{ border: 'none' }}></td>
                                                                                <td style={{ border: 'none' }}></td>
                                                                                <td style={{ border: 'none' }}></td>
                                                                                {/* <td style={{ borderLeft: 'none' }}></td> */}
                                                                            </tr>}
                                                                            {data.IsVisitor && <tr key={Math.random()}>
                                                                                {data.ParentSeminarID == 0 || data.ParentSeminarID == null ?
                                                                                    <td className={"fw-bold"} rowSpan={data.Rowspan} style={{ verticalAlign: 'middle', textAlign: 'center' }}>{data.Day}</td>
                                                                                    : <></>}
                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.DateTime}</td>
                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.SessionName}</td>
                                                                                {/* {data.ParentSeminarID != 0 && data.ParentSeminarID != null ?
                                                                                                                <> */}


                                                                                {/* <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Description}</td>
                                                                                                            {data.SeminarID != 14 ? (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker}</td>
                                                                                                            ) : (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker.split('==').map(item => (
                                                                                                                    <tr className="text-start">{item}</tr>
                                                                                                                ))}</td>
                                                                                                            )} */}


                                                                                {/* </> :
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ verticalAlign: 'middle', textAlign: 'center' }} colSpan={2}>{data.Description}</td>
                                                                                                                } */}

                                                                                <td className="text-center">
                                                                                    {data.SeminarDetailsHtmlRef != '' && data.SeminarDetailsHtmlRef != null ?
                                                                                        <span onClick={() => {
                                                                                            this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                        }}>
                                                                                            <i class="bi bi-info-circle"></i>
                                                                                        </span> : <></>}
                                                                                </td>
                                                                                <td className="text-center" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                                                    {data.ParentSeminarID != 0 && data.ParentSeminarID != null &&
                                                                                        (data.SeminarTypeID == 2 ?
                                                                                            <a
                                                                                                className="btn btn-aqua me-2"
                                                                                                // type="submit"
                                                                                                onClick={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                            >
                                                                                                {data.isSelect ? "Withdraw Request" : "Request for Invite"}
                                                                                            </a>
                                                                                            :
                                                                                            <input type="checkbox"
                                                                                                value={data.isSelect}
                                                                                                checked={data.isSelect}
                                                                                                onChange={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                            />)
                                                                                    }
                                                                                </td>
                                                                            </tr>}
                                                                        </>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>

                                                        <div />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {/* <div className="one-section mt-2">
                                            <div className="col-xl-6 mt-2">
                                                <p className="fw-bold m-0">Note:</p>
                                                {this.state.note.length > 0 && this.state.note.map((item, i) => (
                                                    <p className="ms-2">{i + 1}	{item}</p>
                                                ))}
                                                <label className="d-flex" style={{ marginLeft: '3rem' }} >
                                                </label>
                                            </div>
                                        </div> */}
                                        {this.showMandatoryFields(29, 0) && <div className="one-section mt-2">
                                            <div className="col-xl-6">
                                                <div className="form-row m-2">
                                                    <div >
                                                        <label className="d-flex" >
                                                            <input type="checkbox" style={{ height: 20 }}
                                                                // name={data.ExhRegistrationNotesId}
                                                                value={agreeTerms}
                                                                checked={agreeTerms}
                                                                onClick={e => this.setState({ agreeTerms: !agreeTerms })}
                                                            />I agree all the rules & regulations of delegation process & Exhibition Guidelines of India ITME Society
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        <div className="main-container m-3">
                                            <div className="mt-1 mb-4 d-flex">
                                                <button className="btn btn-outline-secondary rounded-3 ms-2"
                                                    style={{ marginRight: 10 }}
                                                    onClick={(e) => this.onPrevClick(e)}>
                                                    {/* <a style={{ padding: "4px 25px" }} > */}
                                                    Previous
                                                    {/* </a> */}
                                                </button>
                                                {/* <a
                                                className="btn btn-success rounded-0"
                                                style={{ padding: "4px 25px" }}
                                                type="submit"
                                                onClick={(e) => this.onSubmit(e)}
                                            >
                                                Submit
                                            </a> */}
                                                <button className="btn btn-aqua text-white rounded-3 d-block"
                                                    style={{ marginRight: 10 }}
                                                    onClick={(e) => sessionStorage.getItem('DelegateTypeID') == 10 ? this.handleGroupFinalSubmit(e) : this.handleFinalSubmit(e)}>
                                                    {/* <a style={{ padding: "4px 25px" }} > */}
                                                    Next
                                                    {/* </a> */}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div >
                </div >
                {console.log(this.state.showFieldList, '.............', JSON.parse(sessionStorage.getItem('isLinkOpen')))}

                {console.log("sessionStorage.getItem('DelegateDataSS'))==>", sessionStorage.getItem('DelegateDataSS'))}
                <Modal show={this.state.isOpen3} >
                    <div class="modal-header p-2">
                        <h5 class="modal-title modal_title_text text-danger">Confirm Delete</h5>
                        <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen3: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="pop_label">Do you really want to delete this Document?</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer p-1">
                        <div class="form-group text-right mod-fot">
                            <button type="button" class="btn btn-del-pop" onClick={(e) => this.handleDelete(e)}>Yes</button>
                            <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen3: false })}>No</button>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.HTMLEDITOR} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                {/* <h5 class="modal-title modal_title_text text-Primary">
                                                </h5> */}
                            </div>
                            <div class="modal-body">
                                <ul className="p-0">
                                    <li dangerouslySetInnerHTML={{ __html: `${this.state.HtmlContent != null ? this.state.HtmlContent : ''}` }}></li>
                                </ul>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            // this.togglePGCharges(2)
                                            this.setState({
                                                HTMLEDITOR: false,
                                            })
                                        }
                                        }
                                    >Ok</button>
                                    {/* <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                                        onClick={() => this.setState({ isForeignVisitorPop: false })}
                                                    >Close</button> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action, getVistiorRegistarionDetails_action, visitorRegistrationNext_action, deleteVisaDoc_action, visitorRegistrationGroupNext_action, delVisaDoc_action,
    verifyVisitorEmail_action, delegateRegistrationGroupSubmit_action, getDelegateDetailsStep1_action, getExhNoteDetails_action, delegateRegistrationSubmit_action, getDelegateFirldList_action
})(DelegateAdditionalDetails));

